<template>
  <v-expansion-panel class="pt-2">
    <v-expansion-panel-header class="expansion--panel">
      <template v-slot:default="{ open }">
        <v-row no-gutters>
          <v-col cols="4"><v-icon color="white">mdi-tune</v-icon> {{ $t('message.product.measures') }}</v-col>
        </v-row>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="pt-2">
      <v-form ref="measuresForm">
        <v-row>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.length" :label="$t('message.product.length')" dense></v-text-field>
          </v-col>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.width" :label="$t('message.product.width')" dense></v-text-field>
          </v-col>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.thickness" :label="$t('message.product.thickness')" dense></v-text-field>
          </v-col>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.weight" :label="$t('message.product.weight')" dense></v-text-field>
          </v-col>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.grossweight" :label="$t('message.product.grossWeight')" dense></v-text-field>
          </v-col>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.radius" :label="$t('message.product.radius')" dense></v-text-field>
          </v-col>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.area" :label="$t('message.product.area')" dense></v-text-field>
          </v-col>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.minlength" :label="$t('message.product.minLength')" dense></v-text-field>
          </v-col>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.minwidth" :label="$t('message.product.minWidth')" dense></v-text-field>
          </v-col>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.minthickness" :label="$t('message.product.minThickness')" dense></v-text-field>
          </v-col>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.maxlength" :label="$t('message.product.maxLength')" dense></v-text-field>
          </v-col>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.maxwidth" :label="$t('message.product.maxWidth')" dense></v-text-field>
          </v-col>
          <v-col xs="6" sm="3" md="2" lg="1" class="pa-2">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.maxthickness" :label="$t('message.product.maxThickness')" dense></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
export default {
  props: {
    model: {
      type: Object
    }
  }
}
</script>
